import { Avatar, Box, Typography, useTheme } from '@mui/material'

import { IImpactLibraryBaseWithId } from 'src/types'

interface IProps {
  impacts: IImpactLibraryBaseWithId[]
}

export const ImpactsList = ({ impacts }: IProps) => {
  const theme = useTheme()

  if (impacts.length < 1) {
    return (
      <Box sx={{ fontSize: '14px', fontWeight: 500, color: theme.palette.custom.grey2 }}>
        Not found
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxWidth: '700px',
        width: '100%',
      }}
    >
      {impacts.map((item) => (
        <Box
          key={item.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.custom.white,
            gap: '20px',
            justifyContent: 'space-between',
            width: '100%',
            wordWrap: 'break-word',
            border: `1px solid ${theme.palette.custom.grey}`,
            borderRadius: '15px',
            p: '18px',
          }}
        >
          <Avatar
            alt={item.name}
            src={item.image_medium || item.image}
            slotProps={{
              img: { style: { objectFit: 'cover', backgroundColor: '#f7f7f7' } },
            }}
            sx={{
              filter: `drop-shadow(0px 2px 10px ${theme.palette.custom.grey})`,
              width: 80,
              height: 80,
              borderRadius: '50%',
            }}
          />

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: 1.33,
              color: theme.palette.custom.darkBlue2,
              wordWrap: 'break-word',
              wordBreak: 'break-word',
            }}
          >
            <strong>{item.name}</strong>
          </Typography>

          <Box style={{ flexGrow: '1' }} />
          {/* <IconButton
                    sx={{ ml: 'auto', p: 1 }}
                    onClick={(e) => {
                      e.stopPropagation()
                      deleteImpactHandler(impact.id)
                    }}
                  >
                    <DeleteIcon className={classes.deleteIcon} />
                  </IconButton> */}
        </Box>
      ))}
    </Box>
  )
}
